function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.06 4.036c-.026.518-.065 1.05-.092 1.567-.013.172-.013.186-.013.358a.501.501 0 0 1-.505.492.49.49 0 0 1-.504-.478c-.04-.81-.093-1.487-.133-2.297l-.04-.65a.703.703 0 0 1 .505-.717c.318-.08.65.08.783.385.04.106.066.212.066.331-.013.332-.04.678-.066 1.01m-.61 4.38a.68.68 0 0 1-.678-.677.68.68 0 0 1 .677-.677c.372 0 .677.306.664.69.013.359-.305.664-.664.664M5.5 0a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11",
  fill: "#F5A623",
  fillRule: "evenodd"
});

const SvgOrangeExclamation = (_ref) => {
  let {
    svgRef
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgOrangeExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OrangeExclamation.4c183435.svg";
export { ForwardRef as ReactComponent };